import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { QuickSightDashboardResponse } from "../interfaces/quickSightDashboard.interface";
import { getQuickSightDashboardAction } from "../actions/quickSightDashboard.action";

const initialState: QuickSightDashboardResponse = {
    isLoading: false,
    isError: false,
    isSuccess: false,
    status: undefined,
    error: undefined,
    data: {
      embedUrl: undefined,
      requestId: undefined
    }

}

const getQuickSightDashboardSlice = createSlice({
  name: "get-quicksight-dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getQuickSightDashboardAction.pending, (state) => {
      state.isLoading = true;
    });
    // TODO: REMOVED any type HERE
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    builder.addCase(getQuickSightDashboardAction.fulfilled, (state, action: PayloadAction<any>) => {
      state.data.embedUrl = action.payload.body.url;
      state.data.requestId = action.payload.RequestId;
      state.isLoading = false;
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    builder.addCase(getQuickSightDashboardAction.rejected, (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.isError= true;
      state.error = action.payload.Error
    });
  },
});

export default getQuickSightDashboardSlice.reducer;
